import experimentCard from "./ExperimentCard.module.css";

function ExperimentCard({
    h1= "Experiment Title",
    tags= ["Tag 1", "Tag 2", "Tag 3", "Tag 4"],
    number= "##", // automatically inserted number by counting the number of cards
    cover= "",
    link= "https://behance.net/kiansegantini",
}) {
    return (
        <a href={link} target="_blank" rel="noreferrer" id={experimentCard.experimentCard}>
            <div className={experimentCard.left}>
                <h1 className={experimentCard.h1}>{h1}</h1>
                <div className={experimentCard.tags}>
                    {tags.map((tag, index) => (
                        <div key={index} className={experimentCard.tag}>
                            <p>{tag}</p>
                        </div>
                    ))}
                </div>
            </div>
            <p className={experimentCard.cardNumber}>{String(number).padStart(2, "0")}</p>
            <div className={experimentCard.cover}>
                <img className={experimentCard.img} src={cover} alt={h1}/>
                <div className={experimentCard.border}></div>
            </div>
        </a>        
    );
}

export default ExperimentCard;
